<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "catalog_filter_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <web-filter-general-settings [generalFormGroup]="generalFormGroup"></web-filter-general-settings>
        <web-filter-category-settings
            [categoryFormGroup]="categoryFormGroup"
            [catalogView]="catalogView"
        ></web-filter-category-settings>
        <web-filter-price-settings
            [priceFormGroup]="priceFormGroup"
            [catalogView]="catalogView"
        ></web-filter-price-settings>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
